import { API_HOST_NAME } from "../../constants.js"
import useAuthenticatedResources from "../../../../useAuthenticatedResources.js"

const additionalActions = [
  { name: 'check', path: 'check', method: 'POST', member: true }
]

const useDomainsResources = (teamId) => {
  const url = `${API_HOST_NAME}/api/v1/admin/teams/${teamId}/networking/domains`
  return useAuthenticatedResources(url, {}, additionalActions)
}

export default useDomainsResources
